import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]
  
  connect() {
    this.element.addEventListener("turbo:submit-start", this.handleSubmitStart.bind(this))
    this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.handleSubmitStart)
    this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
  }

  handleSubmitStart(event) {
    const submitButtons = this.element.querySelectorAll('.form-submit')
    submitButtons.forEach(button => {
      this.originalText = button.innerHTML
      button.disabled = true
      button.innerHTML = button.dataset.loadingText || '<span class="spinner-border spinner-border-sm me-2"></span>Loading...'
    })
  }

  handleSubmitEnd(event) {
    const submitButtons = this.element.querySelectorAll('.form-submit')
    submitButtons.forEach(button => {
      button.disabled = false
      button.innerHTML = this.originalText
    })
  }
} 